import '../../UsersScreen/UserTable.css'
import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

import ConfirmModal from '../../../components/_modals/ConfirmModal';
import { useSelector } from 'react-redux';
import { selectTranslations } from '../../../services/i18n/i18nSlice';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import plus_img from '../../../assets/images/plus_white.svg'
import { USER_EXAM_STATUS } from '../../../config/constants';
import { fetchCommunications } from '../CommunicationsApi';

// Funzione per recuperare dati dall'API


const CommunicationsTable = (props) => {

    const t = useSelector(selectTranslations)

    const [data, setData] = useState([]);
    const [nextCursor, setNextCursor] = useState(null);
    const [previousCursor, setPreviousCursor] = useState(null);
    const [pageCount, setPageCount] = useState(1)
    const [loading, setLoading] = useState(false);
    const [currentCursor, setCurrentCursor] = useState(null);

    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "Elimina",
        closeCta: "Annulla"
    })

    const fetchDataFromApi = async (cursor) => {
        try {
            // Sostituisci con il tuo endpoint API
            let response = null
              response = await fetchCommunications({
                limit: 15,
                start_cursor: cursor,
                ...(props?.folderId && {
                  folder_id: props?.folderId
                }),
                ...(props?.filter?.limit && {limit: props?.filter?.limit} ),
                ...(props?.filter?.type && {type: props?.filter?.type} ),
                ...(props?.filter?.started !== null && {started: props?.filter?.started} ),
                ...(props?.filter?.ended !== null && {ended: props?.filter?.ended} ),
              }) 
            return response.data;
        } catch (error) {
            console.error("Errore durante il recupero dei dati", error);
            return null;
        }
    };

    const columns = [
        // Colonna per accedere all'email dall'oggetto annidato "details"
        
        {
            accessorFn: (row) => row.communication_id,
            header: "ID",
        },
        {
            accessorFn: (row) => row.title,
            header: "Title",
        },
        {
            accessorFn: (row) => row.type,
            header: "Tipologia",
        },
        {
            accessorFn: (row) => row.disabled,
            header: "Stato",
            cell: ({row}) => (
              <>
                {!row?.disabled ?
                    <span className='status_label' style={{color:`${USER_EXAM_STATUS['completed']?.color}`, background: `${USER_EXAM_STATUS['completed']?.background}`}}>{'Attiva'}</span> 
                :
                    <span className='status_label' style={{color:`${USER_EXAM_STATUS['deleted']?.color}`, background: `${USER_EXAM_STATUS['deleted']?.background}`}}>{USER_EXAM_STATUS['deleted']?.text}</span> 
                }
              </>
            )
        },
        {
            accessorFn: (row) => new Date(row.start_date)?.toLocaleString(),
            header: "Data Ora inizio",
        },
        {
            accessorFn: (row) => new Date(row.end_date)?.toLocaleString(),
            header: "Data Ora fine",
        },
        {
            id: "actions", // ID univoco per la colonna
            header: "Azioni",
            cell: ({ row }) => (
                <div className='d-flex justify-content-between'>
                  <Link target="_blank" to={`/communications/details/${row.original.communication_id}`}>
                    <button className='secondary'>
                      Apri
                    </button>
                  </Link>
                </div>
            ),
        },
    ];

    const getRowStyle = (deleted) => {
        if (deleted) {
            return { backgroundColor: "red", color: "#fff" };
        } 
        return {}; // Default, nessuna colorazione
    };

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    const fetchAndSetData = async (cursor, action) => {
        setLoading(true);
        const response = await fetchDataFromApi(cursor);
        if (response) {
          console.log(response);
          
            setData(response.communications);
            setNextCursor(response.next_cursor);
            setPreviousCursor(previousCursor ? cursor : null);
        }
        setLoading(false);
    };

    // Recupera i dati al montaggio del componente e quando cambia il cursore
    useEffect(() => {
        fetchAndSetData(currentCursor);
    }, [currentCursor]);

    const handleNext = () => {
        if (nextCursor) {
            setCurrentCursor(nextCursor);
            setPageCount(pageCount => pageCount + 1 )
        }
    };

    const handlePrevious = () => {
        if (previousCursor) {
            setCurrentCursor(previousCursor);
            setPageCount(pageCount => pageCount - 1 )
        } else {
            setCurrentCursor();
            setPageCount(pageCount => pageCount - 1 )
        }
    };

    useEffect(() => {
        fetchAndSetData();
    }, [props.filter]);

   return (
    <div className='userTable'> 
      {loading ? (
        <p>Caricamento...</p>
      ) : (
        <table>
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id}>
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id}
                style={getRowStyle(row.original.deleted)}
              >
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div className='d-flex justify-content-between mt-3'>
        <button onClick={handlePrevious} disabled={!previousCursor && pageCount === 1}>
          Precedente
        </button>
        <button onClick={handleNext} disabled={!nextCursor}>
          Successivo
        </button>
      </div>

      <ConfirmModal props={confirmModal} />

    </div>
  );
};

export default CommunicationsTable;
